<template>
    <transition name="fade">
        <svg v-show="show" key="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#0a0a0a" stroke="none" transform="rotate(189.078 50 51)">
            <animateTransform attributeName="transform" type="rotate" dur="1.0638297872340425s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"></animateTransform>
            </path>
        </svg>
    </transition>
</template>

<script>
    export default {
        props: {
            show: Boolean,
        },
    }
</script>

<style lang="scss" scoped>
    svg {
        margin: auto;
        background: none;
        display: block;
        shape-rendering: auto;
        position: absolute;
        left: 30%;
        z-index: 1;
        width: 40%;
        height: 100%;
    }
</style>
